<h4 class="card-title mb-3 main-title">{{ "PatientRecord.steps.procedures" | translate }}</h4>

<h5 class="mb-3 sub-title">{{ "PatientRecord.steps.fillInProcedures" | translate }}</h5>

<app-medical-record [showCategories]="['allergies', 'vaccines', 'procedures']"></app-medical-record>
